module.exports = __webpack_public_path__ + "static/img/lzjd.231e87a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/lzjd.webp
// module id = XOWE
// module chunks = 68